import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-screen",
  "use": "icon-screen-usage",
  "viewBox": "0 0 65.7 65.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 65.7 65.7\" id=\"icon-screen\">\n<path d=\"M32.8,0c18.1,0,32.8,14.7,32.8,32.8S50.9,65.7,32.8,65.7S0,51,0,32.9S14.7,0,32.8,0z M32.8,25.9c-9.5,0-18.6,2.5-27.4,7.4\n\tl-0.7,0.4c0.1,1.7,0.3,3.4,0.6,5H7c12.5,0,22.7,9.8,23.4,22.2c1.6,0.1,3.2,0.1,4.8,0c0.7-12.2,10.7-21.9,23-22.1l0.4,0h1.7\n\tc0.3-1.6,0.6-3.3,0.6-5C51.9,28.5,42.6,25.9,32.8,25.9z M7,43.4l-0.3,0C10,51.6,17,57.8,25.7,60.1l0-0.1\n\tc-1.1-9.2-8.8-16.3-18.2-16.5C7.4,43.4,7,43.4,7,43.4z M58.6,43.4c-9.6,0-17.6,7.3-18.6,16.6c8.6-2.3,15.6-8.5,18.9-16.6L58.6,43.4z\n\t M32.8,28.2c2.6,0,4.7,2.1,4.7,4.7s-2.1,4.7-4.7,4.7s-4.7-2.1-4.7-4.7S30.2,28.2,32.8,28.2z M32.8,4.7C18.9,4.7,7.3,14.8,5.1,28.1\n\tc8.9-4.6,18.1-7,27.7-7s18.9,2.3,27.7,7C58.3,14.8,46.7,4.7,32.8,4.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/screen.svg
// module id = ZxAs
// module chunks = 59